export type typeLocale = {
  label: string,
  value: string,
  flag: string,
}

const result: typeLocale[] = [
  {
    label: '中文_台灣',
    value: 'zh_TW',
    flag: 'tw',
  },
  {
    label: '中文_中國大陸',
    value: 'zh_CN',
    flag: 'cn',
  },
  {
    label: '美國',
    value: 'en_US',
    flag: 'us',
  },
  {
    label: '日本',
    value: 'JP',
    flag: 'jp',
  },
  {
    label: '越南',
    value: 'VN',
    flag: 'vn',
  },
  {
    label: '泰國',
    value: 'TH',
    flag: 'th',
  },
  {
    label: '柬埔寨',
    value: 'KH',
    flag: 'kh',
  },
  {
    label: '馬來西亞',
    value: 'MY',
    flag: 'my',
  },
  {
    label: '太平洋地區',
    value: 'AP',
    flag: 'ap',
  },
  {
    label: '香港',
    value: 'HK',
    flag: 'hk',
  },
  {
    label: '印尼',
    value: 'ID',
    flag: 'id',
  },
  {
    label: '緬甸',
    value: 'MM',
    flag: 'mm',
  },
  {
    label: '新加坡',
    value: 'SG',
    flag: 'sg',
  },
  {
    label: '英文',
    value: 'EN',
    flag: 'gb',
  },
  {
    label: '菲律賓',
    value: 'PH',
    flag: 'ph',
  },
];

export default result;
